import styled, { css } from "styled-components";

const ProductCardBase = styled.a`
	background: #fff;
	cursor: pointer;
	text-decoration: none;
	&:hover {
		color: currentColor;
		background-color: #fff;
	}

	.productPictureWrap {
		position: relative;
		padding-bottom: 100%;
		flex: 0 0 0;

		> img {
			position: absolute;
			z-index: 1;
			left: 0;
			top: 0;
			border-radius: inherit;
		}
	}
`;
export const SingleCardWrap = styled(ProductCardBase)`
	background: #fff;
	/* padding: 0.625rem; */
	display: flex;
	border-radius: 0.375rem;
	overflow: hidden;
`;

export const DoubleCardWrap = styled(ProductCardBase).withConfig({
	shouldForwardProp: (prop) => !["isRollable"].includes(prop),
})<{ isRollable: boolean }>`
	background: #fff;
	display: flex;
	flex-direction: column;
	border-radius: 0.25rem;
	overflow: hidden;
	padding-bottom: 0.5rem;

	${(props: { isRollable: boolean }) => {
		if (props.isRollable) {
			return css`
				width: 9.375rem;
				flex: 0 0 9.375rem;
			`;
		}
		return "";
	}}
`;

export const TripleCardWrap = styled(ProductCardBase)`
	display: inline-block;
	text-align: center;
	border-radius: 0.25rem;
	overflow: hidden;
`;

export const fetchCardBoxByGrid = (column: number) => {
	if (column === 2) {
		return DoubleCardWrap;
	}
	if (column === 3) {
		return TripleCardWrap;
	}
	return SingleCardWrap;
};
